export function formatString(name, size) {
  if (name.length <= size) {
    return name;
  }
  return name.substring(0, size).concat('...');
}
